import { z } from "zod";
import { baseEntitySchema } from "./base";

export const accountIssueStatusSchema = z.enum([
  "cleared",
  "audited",
  "issue",
  "suspended",
]);
export type AccountIssueStatus = z.infer<typeof accountIssueStatusSchema>;

export const accountIssueDataSchema = z.object({
  inventoryId: z.string(),
  status: accountIssueStatusSchema,
  remarks: z.string().optional(),
  recordedByUserId: z.string().optional(),
  recordedByUserEmail: z.string().optional(),
});

export type AccountIssueData = z.infer<typeof accountIssueDataSchema>;
export const accountIssueSchema = baseEntitySchema.merge(accountIssueDataSchema);
export type AccountIssue = z.infer<typeof accountIssueSchema>;
